import { SchemaNames } from "../constnats/schemaConstants"

class SchemaUtil {
    /**
     *
     * @param {*} s1 Schema Required
     * @param {*} s2 Schema Required
     *       Required
     * @returns int
     */
    static comapreSchemas(s1, s2) {
        const isS1Kpi = s1.name === SchemaNames.KPIs;
        const isS2Kpi = s2.name === SchemaNames.KPIs;

        // Prioritize KPI schema by moving it to the front if only one schema is a KPI
        // When both are KPIs, sort by weight and creation date like other schemas
        // Ensures edit and review branches appear after the main branch
        if (isS1Kpi !== isS2Kpi) {
            // KPIs should come first
            return isS1Kpi ? -1 : 1;
        }

        if (s1.weight === s2.weight) {
            return new Date(s1.createdOn) - new Date(s2.createdOn);
        }

        return s1.weight - s2.weight;
    }
}

export default SchemaUtil